'use client';

import { useState } from 'react';
import { useWorkflowStore } from '../../../stores/workflowStore';

interface ExportCSVConfigProps {
  nodeId: string;
  config: { fileName?: string; separator?: string; encoding?: string };
}

export function ExportCSVConfig({ nodeId, config }: ExportCSVConfigProps) {
  const { updateNodeConfig } = useWorkflowStore();
  const [fileName, setFileName]   = useState(config.fileName  || 'output');
  const [separator, setSeparator] = useState(config.separator || ',');
  const [encoding, setEncoding]   = useState(config.encoding  || 'utf-8');

  const save = (updates: Partial<typeof config>) => {
    updateNodeConfig(nodeId, { type: 'export_csv', params: { fileName, separator, encoding, ...updates } });
  };

  return (
    <div className="space-y-4">
      <div className="space-y-1.5">
        <label className="text-xs font-medium text-zinc-500">文件名（不含扩展名）</label>
        <input type="text" placeholder="output" value={fileName}
          onChange={(e) => { setFileName(e.target.value); save({ fileName: e.target.value }); }}
          className="w-full text-sm bg-white border border-zinc-200 rounded-lg px-3 py-2.5 focus:outline-none focus:ring-2 focus:ring-emerald-500/20 focus:border-emerald-500 placeholder:text-zinc-400"
        />
        <p className="text-xs text-zinc-400">最终下载文件为 <code className="bg-zinc-100 px-1 rounded">{fileName || 'output'}.csv</code></p>
      </div>
      <div className="grid grid-cols-2 gap-3">
        <div className="space-y-1.5">
          <label className="text-xs font-medium text-zinc-500">分隔符</label>
          <select value={separator} onChange={(e) => { setSeparator(e.target.value); save({ separator: e.target.value }); }}
            className="w-full text-sm bg-white border border-zinc-200 rounded-lg px-3 py-2.5 focus:outline-none focus:ring-2 focus:ring-emerald-500/20 focus:border-emerald-500"
          >
            <option value=",">逗号 (,)</option>
            <option value="\t">制表符 (Tab)</option>
            <option value=";">分号 (;)</option>
            <option value="|">竖线 (|)</option>
          </select>
        </div>
        <div className="space-y-1.5">
          <label className="text-xs font-medium text-zinc-500">编码格式</label>
          <select value={encoding} onChange={(e) => { setEncoding(e.target.value); save({ encoding: e.target.value }); }}
            className="w-full text-sm bg-white border border-zinc-200 rounded-lg px-3 py-2.5 focus:outline-none focus:ring-2 focus:ring-emerald-500/20 focus:border-emerald-500"
          >
            <option value="utf-8">UTF-8</option>
            <option value="gbk">GBK</option>
            <option value="gb2312">GB2312</option>
          </select>
        </div>
      </div>
    </div>
  );
}
